import React from 'react';
import './PaymentPanel.css';

const PaymentPanel = ({ orderItems }) => {
  const total = orderItems.reduce((sum, item) => {
    return sum + (item.price * item.quantity);
  }, 0);

  return (
    <div className="payment-panel">
      <div className="pay-section">
        <span className="pay-label">Ticket:</span>
        <span className="pay-amount">{Math.round(total).toLocaleString('es-AR')}</span>
      </div>
    </div>
  );
};

export default PaymentPanel;